import type {GraphAtom} from "../graph/GraphAtom"
import {MolecularGraph} from "../graph/MolecularGraph"
import {extractorUtil} from "./extractorUtil";

export const rGroupFinder = {
    get: (graph: MolecularGraph, terminalAtoms: GraphAtom[]) => {
        // Go through each bond connected to the terminal atoms and add the immediate commections
        // to the set.
        const allConnectedAtoms = terminalAtoms.reduce((acc, currAtom) => {
            graph.getBondsAttachedTo(currAtom).forEach(b => {
                const other = b.getOtherAtom(currAtom);
                if(other.atomicNumber !== 1)
                    acc.add(b.getOtherAtom(currAtom))
            });

            return acc;
        }, new Set<GraphAtom>())

        terminalAtoms.forEach(a => allConnectedAtoms.delete(a));

        // Sort C first.
        return extractorUtil.sortCFirst(Array.from(allConnectedAtoms));

    }
}
